import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import requestErrorTreatment from "@shared/utils/requestErrorTreatment";
import { tiledeskStatusQueryKey } from "@modules/tiledesk/services/queries/getTiledeskStatus";
import { TiledeskStatus } from "@modules/tiledesk/types";
import { deleteTiledeskService } from "./service";

export function useDeleteTiledeskMutation(agreementId: string) {
  const { open } = useNotification();
  const translate = useTranslate();
  const queryClient = useQueryClient();

  return useMutation<TiledeskStatus, ApiError, void>({
    mutationFn: () => deleteTiledeskService(agreementId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tiledeskStatusQueryKey(agreementId),
      });
      open?.({
        type: "success",
        message: translate("tiledesk.success.delete"),
      });
    },
    onError: (error: ApiError) => {
      requestErrorTreatment(error, open);
    },
  });
}
